export const CONTRACT_TYPE_MODEL = "contract-type";

const contractTypeModel = {
  contractType: "",
  name: "",
  originalName: ""
};

export default contractTypeModel;
